module.exports = __webpack_public_path__ + "static/media/Detail.fd71a130.md";